import type { IconNamesType } from 'ksnm-common-ui/lib/Icon/types';

import type { ReportPackageInfoDto } from '@src/api';

export const submissionDocuments: { value: keyof ReportPackageInfoDto; title: string; iconName: IconNamesType }[] = [
  {
    value: 'reportSettingsSignTCC',
    title: 'Представление по телекоммуникационным каналам связи через оператора электронного документооборота',
    iconName: 'markEmailRead',
  },
  {
    value: 'signInfoSystem',
    title: 'Представление через информационные системы',
    iconName: 'screenShare',
  },
  {
    value: 'autoForm',
    title: 'Автоматическое формирование налоговой отчетности',
    iconName: 'topic',
  },
  {
    value: 'formTCC',
    title: 'Форматы представления по телекоммуникационным каналам связи через оператора электронного документооборота',
    iconName: 'postAdd',
  },
];

export const functionality: { value: keyof ReportPackageInfoDto; title: string; iconName: IconNamesType }[] = [
  {
    value: 'arbitaryReport',
    title: 'Построение произвольных пользовательских отчетов',
    iconName: 'pieChartOutline',
  },
  {
    value: 'autoDecodeDetail',
    title: 'Автоматическая расшифровка и детализация',
    iconName: 'rule',
  },
  {
    value: 'autoCheckVersion',
    title: 'Автоматическое сравнение разных версий налоговой отчетности',
    iconName: 'ballot',
  },
  {
    value: 'dataFiltering',
    title: 'Фильтрация данных',
    iconName: 'filterList',
  },
  {
    value: 'dataSorting',
    title: 'Сортировка данных',
    iconName: 'sort',
  },
  {
    value: 'dataGrouping',
    title: 'Группировка данных',
    iconName: 'lowPriority',
  },
  {
    value: 'totalCalc',
    title: 'Расчет итогов',
    iconName: 'calculate',
  },
  {
    value: 'dataExport',
    title: 'Экспорт данных',
    iconName: 'exportBox',
  },
  {
    value: 'dataPrint',
    title: 'Вывод данных на печать',
    iconName: 'print',
  },
  {
    value: 'fulltextSearchRus',
    title: 'Полнотекстовый поиск на русском языке',
    iconName: 'fontDownload',
  },
];

export const reportSettings: { value: keyof ReportPackageInfoDto; title: string }[] = [
  { title: 'Тип отчета', value: 'reportTypeCode' },
  { title: 'Номер версии', value: 'reportVersionVersion' },
  { title: 'Ссылка на внешний код версии', value: 'externalVersionCode' },
  { title: 'Дата начала действия версии', value: 'reportVersionBeginDate' },
  { title: 'Информационная система', value: 'infoSystemCode' },
  { title: 'Таблица-иcточник', value: 'reportSettingsTableSource' },
  { title: 'Структура-источник файла', value: 'reportSettingsFileStructure' },
  { title: 'Таблица-получатель', value: 'reportSettingsTableReceiver' },
  { title: 'Открыть в новом окне', value: 'reportSettingsNewWindow' },
  { title: 'Cсылка URL', value: 'reportSettingsUrl' },
  { title: 'Параметр 1 для URL', value: 'urlP1' },
  { title: 'Параметр 2 для URL', value: 'urlP2' },
  { title: 'Параметр 3 для URL', value: 'urlP3' },
  { title: 'Параметр 4 для URL', value: 'urlP4' },
  { title: 'Параметр 5 для URL', value: 'urlP5' },
  { title: 'Параметр 6 для URL', value: 'urlP6' },
  { title: 'Параметр 7 для URL', value: 'urlP7' },
  { title: 'Параметр 8 для URL', value: 'urlP8' },
  { title: 'Параметр 9 для URL', value: 'urlP9' },
  { title: 'Параметр 10 для URL', value: 'urlP10' },
  { title: 'Внешний код информационной системы', value: 'reportSettingsCodeExt' },
  { title: 'Код типа источника', value: 'sourceTypeCode' },
  { title: 'Пользователь', value: 'reportPackageUserName' },
];

export const additionalPackageInfo: { value: keyof ReportPackageInfoDto; title: string }[] = [
  { title: 'Код пакета', value: 'reportPackageCode' },
  { title: 'Внешний код пакета', value: 'reportPackageCodeExt' },
  { title: 'Год', value: 'reportPackageYear' },
  { title: 'Период', value: 'periodCode' },
  { title: 'Корректировка', value: 'reportPackageCorrection' },
  { title: 'Количество записей', value: 'reportPublishItemNumber' },
  { title: 'Размер (МБ)', value: 'reportPublishSize' },
  { title: 'Пользователь', value: 'reportPackageUserName' },
];
